import { useCallback, useEffect, useState } from 'react';
import useRequest from 'hooks/useRequest';

// Hook para leer alertas regulatorias no resueltas de un cliente.
// Idempotente contra GET /clientes/:idCliente/alerts. Las alertas las produce
// el job nocturno regulatoryAlertsChecker (ver API-PROAPP/src/jobs/).
export function useRegulatoryAlerts(idCliente) {
  const [alerts, setAlerts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { request } = useRequest();

  const refresh = useCallback(async () => {
    if (!idCliente) return [];
    setLoading(true);
    setError(null);
    try {
      const data = await request(`/clientes/${idCliente}/alerts`, 'GET');
      const rows = Array.isArray(data) ? data : [];
      setAlerts(rows);
      return rows;
    } catch (err) {
      setError(err);
      return [];
    } finally {
      setLoading(false);
    }
  }, [idCliente, request]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { alerts, loading, error, refresh };
}

// Variante para un equipo particular. Alimenta el tab "Alertas" del
// EquipoDetailDrawer.
export function useRegulatoryAlertsByEquipo(idEquipo) {
  const [alerts, setAlerts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { request } = useRequest();

  const refresh = useCallback(async () => {
    if (!idEquipo) return [];
    setLoading(true);
    setError(null);
    try {
      const data = await request(`/equipos/${idEquipo}/alerts`, 'GET');
      const rows = Array.isArray(data) ? data : [];
      setAlerts(rows);
      return rows;
    } catch (err) {
      setError(err);
      return [];
    } finally {
      setLoading(false);
    }
  }, [idEquipo, request]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { alerts, loading, error, refresh };
}
